module.exports = __webpack_public_path__ + "img/planta2.da9e0c84.png";